import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getMetricGroupOrderIds, getSvgMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import IndexBanner from "../IndexBanner";

const EconomyMetrics = ({ indicators, metadata, categorizedData, geoDetails, tab, geoTag, selectionActive }: MetricPanelProps) => {   
    const econOrders = getMetricGroupOrderIds(tab);

    const sortedEconMetrics = econOrders.map((order: number[]) => 
        categorizedData.Economy
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
    console.log('Economy data:', sortedEconMetrics);

    const economy: DisaggregatedMetric[] = sortedEconMetrics[0];

    let metricsForTab = indicators; // Get metrics for the current tab

    // Find the indexMetric from metadata based on the current tab
    const indexMetricId = metadata?.find((metric) => metric.metric_source_type === "index" && metric.metric_category.toLowerCase() === tab.toLowerCase())?.id || 0;

    // Find the full indicator object that matches indexMetric
    const indexMetricData = indicators.find(metric => metric.id === Number(indexMetricId)) || null;

    // Exclude the index metric from the list of metrics
    if (indexMetricId) {
        metricsForTab = metricsForTab.filter((metric) => metric.id !== indexMetricId);
    }

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }


    return (
        <div className="h-screen">
            <div className="mb-2">
                <IndexBanner
                    key={indexMetricId}
                    metric={indexMetricData}
                    svg={undefined}
                    disaggData={indicators}
                    geoDetails={geoDetails}
                    geoTag={geoTag}
                    selectionActive={selectionActive}
                />
            </div>
            <p className="text-[10px] text-lacey-text mx-4">
            Activate the <span aria-hidden="true">🛈</span> <strong>button</strong> to expand additional information about a metric.
            </p>
            <p className="text-lacey-text mx-4 text-[10px]">Data updates published August 14, 2026.</p>
            
            <div className="mx-auto px-4 pb-8 pt-4">
                <div className="grid grid-cols-2 gap-4">
                    {economy.map(metric => (
                        <MetricCard
                            key={metric.id}
                            metric={metric}
                            width="w-full"
                            svg={getSvgMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default EconomyMetrics;